import { motion } from "framer-motion";
import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Home } from "lucide-react";

const STEP_ANIMATION = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

const PROPERTY_TYPES = [
  { value: "studio", label: "Studio" },
  { value: "flat", label: "Flat" },
  { value: "house", label: "House" },
  { value: "office", label: "Office" },
];

export const StepPropertyDetails = ({ formData, updateFormData }) => (
  <motion.div key="step2" {...STEP_ANIMATION} className="space-y-6">
    <div className="text-center mb-8">
      <div className="w-16 h-16 bg-[#FF5A1F]/10 mx-auto flex items-center justify-center mb-4">
        <Home className="w-8 h-8 text-[#FF5A1F]" />
      </div>
      <h2 className="text-2xl font-['Outfit'] font-bold text-[#0F172A]">Property Details</h2>
      <p className="text-slate-600 mt-2">Tell us about your current property</p>
    </div>

    <div className="space-y-4">
      <div>
        <Label className="label-text">Property Type *</Label>
        <Select value={formData.property_type} onValueChange={(v) => updateFormData("property_type", v)}>
          <SelectTrigger className="h-12" data-testid="property-type-select">
            <SelectValue placeholder="Select property type" />
          </SelectTrigger>
          <SelectContent>
            {PROPERTY_TYPES.map((type) => (
              <SelectItem key={type.value} value={type.value}>{type.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label className="label-text">Number of Bedrooms *</Label>
        <Select value={String(formData.bedrooms)} onValueChange={(v) => updateFormData("bedrooms", parseInt(v))}>
          <SelectTrigger className="h-12" data-testid="bedrooms-select">
            <SelectValue placeholder="Select bedrooms" />
          </SelectTrigger>
          <SelectContent>
            {[0, 1, 2, 3, 4, 5, 6].map((num) => (
              <SelectItem key={num} value={String(num)}>{num === 0 ? "Studio" : `${num} Bedroom${num > 1 ? 's' : ''}`}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label className="label-text">Floor Level</Label>
        <Select value={String(formData.floor_level)} onValueChange={(v) => updateFormData("floor_level", parseInt(v))}>
          <SelectTrigger className="h-12" data-testid="floor-level-select">
            <SelectValue placeholder="Select floor" />
          </SelectTrigger>
          <SelectContent>
            {[0, 1, 2, 3, 4, 5].map((num) => (
              <SelectItem key={num} value={String(num)}>{num === 0 ? "Ground Floor" : `Floor ${num}`}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-3 pt-4">
        <div className="flex items-center space-x-3">
          <Checkbox
            id="lift"
            checked={formData.lift_available}
            onCheckedChange={(checked) => updateFormData("lift_available", checked)}
            data-testid="lift-checkbox"
          />
          <Label htmlFor="lift" className="text-sm font-medium cursor-pointer">Lift available</Label>
        </div>
        <div className="flex items-center space-x-3">
          <Checkbox
            id="parking"
            checked={formData.parking_restrictions}
            onCheckedChange={(checked) => updateFormData("parking_restrictions", checked)}
            data-testid="parking-checkbox"
          />
          <Label htmlFor="parking" className="text-sm font-medium cursor-pointer">Parking restrictions (long carry required)</Label>
        </div>
      </div>
    </div>
  </motion.div>
);
